// Convert input string to array by splitting with comma and space
export function covertStringToArray(value: string | undefined): string[] {
  return value?.split(/[\s,]+/).filter(Boolean) ?? [];
}
